module.exports = __webpack_public_path__ + "img/cars.c378ac96.gif";